import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import overlayimg from "./../../assets/images/resource/uipath.jpg";
import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/rpa-banner.png";
import { Link} from "react-router-dom";

const AI_RPA_Implementation = () => {
  pageTitle("AI & RPA Implementation");

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper" style={{ backgroundImage: `url(${aiAccounting})` }}>
        {/* <img src={aiAccounting} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          <img
            src={overlayimg}
            alt="RPA Icon"
            className="ai-overlay-corner-img"
          />
          <h2 className="rpa-af-title ">RPA IMPLEMENTATION</h2>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container container">
          <div className="siw-rpa-content">
            <span className="siw-rpa-tag">
              Your partner for successful automation implementations
            </span>

            <div className="siw-rpa-text">
              <p>
                Rapid industry and technology shifts demand a strong focus on
                value creation. RPA helps organizations respond to disruption by
                delivering measurable ROI across core functions including
                finance, supply chain, operations, human resources, marketing,
                sales, customer service, and audit.
              </p>
            </div>
            <p className="siw-rpa-desc">
              By implementing RPA, <span className="SiW">SiW</span> helps
              organizations streamline repetitive and manual activities, driving
              greater operational efficiency. This enables teams to reallocate
              effort toward strategic, value-driven, and creative
              work-maximizing productivity and organizational impact.
            </p>
          </div>

          {/* <div className="siw-rpa-cta">
            <p>
              With automation in place, organizations reduce manual effort and
              rework, lower error rates, and enhance data accuracy-driving
              higher employee satisfaction and improved customer service.
            </p>
          </div> */}
          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>
              Let’s Build Your Intelligent Automation
            </h4>
            <p>
              Through RPA implementation,{" "}
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              empowers organizations to automate repetitive processes, improving
              efficiency and accuracy. This allows teams to focus on strategic
              initiatives and high-value activities that drive measurable
              business impact.
            </p>
            <h4>
              Call us at{" "}
              <a href="tel:+6590059743" style={{ color: "rgb(230, 233, 55)" }}>
                +65 9005 9743
              </a>{" "}
              to discuss your RPA Implementation
            </h4>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Schedule a Meeting
            </a>
          </div>
        </div>
      </section>

      <section className="siw-approach-implementation">
        <div className="siw-approach-implementation-container container">
          <span className="siw-approach-implementation-label">
            OUR APPROACH
          </span>

          <h2 className="siw-approach-implementation-title">
            Keys to a Successful RPA Implementation
          </h2>

          <div className="siw-approach-implementation-content">
            {/* LEFT CONTENT */}
            <div className="siw-approach-implementation-text">
              <p>
                The success of your RPA implementation is contingent on two
                essential components.
              </p>

              <p>
                <strong>First</strong>, selecting the right automation
                technology for your organizational needs and partnering with
                experienced experts to integrate it seamlessly. This includes
                the implementation and establishment of a{" "}
                <Link to="/RPA-AI-Coe">
                  <span className="siw-approach-implementation-highlight">
                    governance framework
                  </span>
                </Link>{" "}
                We apply proven best practices to deliver a scalable automation
                program that drives continuous success and long-term business
                value.
              </p>

              <p>
                <strong>Second</strong>, adopting an agile methodology for RPA.
                An agile approach reduces risk and accelerates delivery,
                enabling faster realization of business value.{" "}
                <span className="SiW">SiW</span> leverages Sprint 0 to conduct
                focused workshops that break down processes and develop Process
                Definition Documents (PDDs). Process backlogs are created and
                continuously refined throughout each Sprint. As new requirements
                emerge, they are incorporated and addressed within the Sprints.
                Automations are delivered incrementally during each
                Sprint—rather than at the end of a waterfall
                lifecycle—significantly accelerating deployment and business
                value payback.
              </p>
            </div>

            {/* RIGHT QUOTE CARD */}
            <div className="siw-approach-implementation-quote">
              <div className="siw-approach-implementation-quote-icon">“</div>

              <p className="siw-approach-implementation-quote-text">
                Successful implementation of AI & RPA can improve output quality
                levels by <strong>35%</strong>.
              </p>

              <span className="siw-approach-implementation-quote-source">
                Source: Research Business Technographics®, Forrester
              </span>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_RPA_Implementation;
